import { InputProps } from "@common/types";
import {
  getInputPrimitiveClassName,
  inputPrimitiveVariants,
} from "@app/components/ui/input";
import { cn } from "@app/lib/utils";
import { Text } from "../text";
import { Label } from "./Label";

export function getInputClassName(
  variant: keyof typeof inputPrimitiveVariants = "default",
) {
  return getInputPrimitiveClassName(variant, "disabled:opacity-50");
}

export function Input({
  label,
  error,
  children,
  hint,
  icon,
  iconPosition = "start",
  success,
  className,
  footer,
}: InputProps & { className?: string }) {
  const errorMessage = error
    ? typeof error === "string"
      ? error
      : typeof error === "object"
        ? error.message
        : false
    : false;

  return (
    <Label
      label={label}
      variant={error ? "danger" : success ? "success" : "default"}
      className={className}
    >
      <div className={cn(icon && "relative flex items-center")}>
        {children}
        {icon &&
          icon !== true &&
          (iconPosition !== "none" ? (
            <div
              className={cn(
                "absolute inset-y-0 flex w-11 items-center justify-center text-muted-foreground [&_svg]:h-[18px] [&_svg]:w-[18px] [&_svg]:stroke-[2]",
                iconPosition === "end" ? "end-0" : "start-0",
              )}
            >
              {icon}
            </div>
          ) : (
            icon
          ))}
      </div>
      {footer}
      {hint && (
        <Text variant="muted" block className="mt-1">
          {hint}
        </Text>
      )}
      {errorMessage ? (
        <Text variant="danger" block className="mt-1 text-xs">
          {errorMessage}
        </Text>
      ) : success ? (
        <Text variant="success" block className="mt-1 text-xs">
          {success}
        </Text>
      ) : null}
    </Label>
  );
}
